import {createStore, compose, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import rootReducerFunc from '../reducers';
import {routerMiddleware} from 'react-router-redux';
import {browserHistory} from 'react-router';
import {createLogger} from 'redux-logger';
import analyticsMiddleware from './middleware/analytics';
import refreshTokenMiddleware from './middleware/refreshToken';

const logger = createLogger({collapsed: true});
const middleware = routerMiddleware(browserHistory);

export default function configureStore(initialState) {
  const rootReducer = rootReducerFunc();
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      // Add other middleware on this line...
      applyMiddleware(thunk, middleware, analyticsMiddleware, refreshTokenMiddleware, logger),
      window.devToolsExtension ? window.devToolsExtension() : f => f // add support for Redux dev tools
    )
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.dev.js